import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TransportState } from 'sip.js'
import { getCallToNumberParam } from 'utils/urlUtils'
import { callTo } from 'store/actions/call'

export const useCallToUrlParameter = () => {
    const dispatch = useDispatch()
    const { transportStatus } = useSelector((state) => state.userAgent)
    const [callToNumber] = useState(getCallToNumberParam())

    useEffect(() => {
        if (callToNumber && transportStatus === TransportState.Connected) {
            const number = callToNumber
            dispatch(callTo(number))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callToNumber])
}
